import React from 'react';
import { CheckCircle, Star, Shield, Zap, Heart, Trophy } from 'lucide-react';
import { contactInfo } from '../data/mock';

const GuaranteesSection = () => {
  const guarantees = [
    {
      icon: CheckCircle,
      title: "Résultats Garantis",
      description: "Le grand marabout africain s'engage à mettre en œuvre tous les moyens nécessaires pour faire revenir votre ex. Taux de réussite de 98%."
    },
    {
      icon: Shield,
      title: "Paiement Sécurisé",
      description: "Aucun paiement n'est demandé avant la première consultation. Vous ne payez que si vous êtes satisfait de l'analyse du spécialiste."
    },
    {
      icon: Heart,
      title: "Suivi Personnalisé",
      description: "Le marabout vous accompagne personnellement tout au long du processus jusqu'à ce que votre ex revienne vers vous définitivement."
    },
    {
      icon: Zap,
      title: "Rituels Puissants",
      description: "Les rituels ancestraux africains sont parmi les plus puissants au monde. Magie blanche, noire ou rouge selon votre situation."
    },
    {
      icon: Star,
      title: "Satisfaction Client",
      description: "Plus de 290 clients satisfaits témoignent de l'efficacité des rituels de retour affectif du grand marabout."
    },
    {
      icon: Trophy,
      title: "N°1 du Retour Affectif",
      description: "Reconnu comme l'un des meilleurs marabouts africains spécialisés dans le retour de l'être aimé depuis plus de 30 ans."
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-black to-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-4 sm:px-5 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-500 text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-6">
            Nos Garanties
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6 px-2">
            Pourquoi faire confiance au <span className="text-amber-500">Grand Marabout</span> ?
          </h2>
          <p className="text-gray-300 text-base sm:text-xl max-w-3xl mx-auto leading-relaxed px-2">
            Votre satisfaction et votre bonheur sont la priorité absolue du spécialiste du retour affectif. 
            Découvrez les garanties qui font de ce grand marabout africain le choix numéro 1 pour récupérer votre ex.
          </p>
        </div>

        {/* Guarantees Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {guarantees.map((guarantee, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-6 bg-gray-900/30 border border-amber-500/10 rounded-xl hover:border-amber-500/30 transition-all duration-300"
            >
              <div className="w-12 h-12 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <guarantee.icon className="w-6 h-6 text-amber-500" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-white mb-2">{guarantee.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{guarantee.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Text */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 text-sm sm:text-base max-w-4xl mx-auto">
            Le <strong className="text-white">grand marabout africain</strong> est un <strong className="text-amber-500">spécialiste sérieux et reconnu</strong> du retour affectif. 
            Ne perdez plus de temps avec des charlatans. Faites confiance à un vrai professionnel 
            avec plus de 30 ans d'expérience et des milliers de témoignages vérifiés.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GuaranteesSection;
